<template>
  <div style="margin-bottom:300px;">
  
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->


  <div  v-if="taskExist" class="text-center"  style="margin-top:30px;margin-bottom:50px;max-width:300px;margin-left:auto;margin-right:auto;">
     <p-button type="default"  block round  @click.prevent="goToTask">View Task & Resolution</p-button> 
    </div>
    
    

<div >
    <h4  class="title">
    Change: Company Details
    </h4>
</div>



  
  <card  class="form-horizontal">


    
	
	 <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Type Of Change</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">
        	 <span v-if="cic.ch_type=='ch_address'">Change In Company Address</span>
      		 <span v-if="cic.ch_type=='ch_coy_name'">Change In Company Name</span>
      		 <span v-if="cic.ch_type=='ch_coy_fye'">Change In Company Financial Year-end Date</span>
      		  <span v-if="cic.ch_type=='ch_coy_activity'">Change In Company's Principal Activities</span>
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Change To</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail1">
			 <span v-if="cic.ch_type=='ch_address' ||  cic.ch_type=='ch_coy_name'">{{cic.str_field_1}}</span>
			  <span v-if="cic.ch_type=='ch_coy_fye'">{{cic.date_field_1}}</span>
			   <span v-if="cic.ch_type=='ch_coy_activity'">
				   <span v-if="cic.str_field_1">
				   ({{cic.str_field_1}}) {{cic.str_field_2}} - {{cic.str_field_3}}
				   <br/>
				   </span>
					 <span v-if="cic.str_field_4">
			   			({{cic.str_field_4}}) {{cic.str_field_5}} - {{cic.str_field_6}}
			  	    </span>
			   
			   </span>
		</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


    
    <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="cic.effective_date" type="date" placeholder="Select A Date"
                              v-validate="modelValidations.effective_date" >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
	
    
    
    <div v-if="0" class="row">
      <label class="col-sm-2 col-form-label">Filing Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="cic.filing_date" type="date" placeholder="Select A Date"
                               >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
       	   <textarea 
        		 cols="45" rows="10"
                  name="notes"
                  v-model="cic.notes">
       	 </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
             	<span style="font-size:11px;"><i> * Add your notes, ACRA transaction code, etc.</i></span>

      </div>
    </div>
	
    

    


    
    

    
    
    <div  v-if="editOc && taskExist" class="text-center"  style="margin-top:30px;margin-bottom:50px;max-width:300px;margin-left:auto;margin-right:auto;">
     <p-button type="info" outline block round  @click.prevent="goToTask">View Task & Resolution</p-button> 
    </div>
    
</card>
          
          
    
   <div style="margin-top:100px;">
	<h4 class="title">Status</h4>
   </div>
   <card style="margin-bottom:100px;">
   	 <div class="row">
      <label class="col-sm-2 col-form-label">Change: Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="cic.status">
                    <el-option v-for="option in selects.change_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
   
   
   </card>
   
   
   
    <!-- start register card-->
   <div style="margin-top:100px;">
	<h4 class="title">Company Registers</h4>
   </div>
   
   <card style="margin-bottom:100px;">
   
   	 <div class="row" >
      <label class="col-sm-2 col-form-label">Insert This Change Into Company's Registers</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Position"
                             v-model="cic.is_official"
                             >
                    <el-option v-for="option in selects.is_official"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
   </card>
   <!-- end register card-->
   
   
    
    
    <h4 style="font-weight:bold;">Actions</h4>	  
	<card>
		  <div >
    		  <p-button   type="info" @click.prevent="updateCompanyInfoChange">Update Company Info Change</p-button>
    		</div>
	</card>
   
   
   

   
	<p-button v-if="editOc" type="danger"  @click="deleteOc()" >
                <i slot="label" class="nc-icon nc-simple-remove"></i>
                <span style=""> Delete This Change: Officer </span>
     </p-button>
     

  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     		this.showSearchBar = false;
     		
     		
     		
     		let uri = this.$base_url+'/api/v1/entities/view_company_info_change/id/'+ this.$route.params.cicid;
			 ApiService.get(uri).then(response => {
		
				this.cic = response.data.cic;
				if(this.cic.task_id){
					this.taskExist = true;
				}
				else{
					this.cic.task_id = 0;
				}
		
			
			})
     		
     
    	
     	if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				//this.createForm = false
				//this.model = response.data.entity;
				this.coy = response.data.entity;
				
			
			})
      	}//get connected entity info
      	
      	
      
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	cicid: this.$route.params.oid,
    	cic: {},
    	pid: 0,
    	createForm: false,
    	editOc: false,
    	taskExist: false,
    	showSearchBar: true,
    	createChangeForm: false,
    	search_id_num: '',
    	personFound: false,
    	showTransferFrom: false,
    	oc_position: 1,
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_contact_person: 2,
          effective_date: '',
          position: 2,
          nationality:'',
          gov_id:'',
          email:'',
          contact_num:'',
          eid: this.$route.params.eid

        },
        modelValidations: {
          first_name: {
            required: true
          },
          last_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
        
          is_contact_person: {
            required: true,
          },
          effective_date: {
            required: true,
          },
  
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
          
          
          
        },
        
        selects: {

		  change_status: [
            {value: 1, label: 'Pending'},
            {value: 4, label: 'Completed'},
		   ],
		   is_official:[
		   	 {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   
		   ],
		  is_contact:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] ,

        },
      }
    },
    methods:{
       deleteOc(){
       		const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'Any resolution or task connected to this change will also be deleted.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/officers/delete_oc/'+ vm.$route.params.ocid;
          	 
     	  	 ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'This Change: Officer has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					 vm.$router.push( '/view-entity/'+vm.$route.params.eid);
				
				})
				//end swal
            })
         
            
          })
       }, //end delete oc
       goToTask(){
       		this.$router.push( '/edit-task/'+ this.cic.task_id + '/entity/'+ this.$route.params.eid)
       },
       goToCreateTaskDetails(){
       		
       		let task_name_sys = "oc";
       		       		
       
       		this.$router.push( '/create-task-details/'+ this.$route.params.eid+"/"+task_name_sys+"/"+this.$route.params.ocid +"/"+this.oc.task_id+"/"+this.oc.status)
       },
       onTransactionTypeChange(event){
       		if(this.shares.transaction_type == 3){
       			let uri = this.$base_url+'/api/v1/shareholders/entity/'+this.$route.params.eid;
       		
      			ApiService.get(uri).then(response => {
      				
      				this.selects.shareholders_list = response.data.shareholders;
      				this.showTransferFrom = true;
   
      				
      			});
       		
       		}else{
       			this.showTransferFrom = false;
       		}
       
       },
       searchPerson(){
       		let search_term = "NONE";
       		if(this.search_id_num){
       			search_term = this.search_id_num
       		}
       		let uri = this.$base_url+'/api/v1/shareholders/search/'+search_term;
       		
       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){
      				
      					this.model = response.data.person;
      					this.pid = response.data.person.id;
      					this.personFound = true;
      					this.createForm = false;
      					this.createChangeForm = true;
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'This person has not been added yet.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
							vm.createForm = true;
							vm.personFound = false;
							vm.createChangeForm = true;
				
						})
      				
      					
      				}
         		
     		 })
    	
    	},

       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    
	    updateCompanyInfoChange(){
	    	const vm = this;
	  		swal({
					title: 'Warning!',
					text: "Changing the status to Completed will automatically update the records for this company.",
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes, proceed.',
					buttonsStyling: false
				  }).then(function () {
						vm.updateCompanyInfoChange_next();
					}
					, function(dismiss) {
 						 if (dismiss === 'cancel'){
								return;
 						 }

 					  }
					)//end swal
	
	    
	    },
	    
	  updateCompanyInfoChange_next(){
	  	 this.$validator.validateAll().then(isValid => {
	  	 	let uri = this.$base_url+'/api/v1/entities/update_cic';
       	      		
       		
       		const vm = this;
      		ApiService.post(uri, {
      			'eid': this.eid,
      			'cicid': this.$route.params.cicid,
      			'cic': this.cic
      		
      		}).then(response => {
      			
      			vm.$router.push( '/edit-task/'+ response.data.cic.task_id + "/entity/" + response.data.cic.entity_id);
      		
      		})
	  	 
	  	 
	  	 });
	  },  
	    
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


